import Constants from '@/Constants';
import { LessonData } from '@/models/LessonData';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { decreaseTotalSuggested, increaseTotalSuggested } from '../item/action';
import {
    addContentToCourseFailure,
    addContentToCourseSucess,
    deleteContentFromCourseFailure,
    deleteContentFromCourseSuccess,
    getAddedContentListFailure,
    getAddedContentListRequest,
    getAddedContentListSuccess,
    reorderContentListFailure,
    reorderContentListSuccess,
} from './actions';
import { StudentTypes } from './types';

export function* addContentToCourseRequest(
    action: PayloadAction<StudentTypes.ADD_CONTENT_TO_COURSE_REQUEST, { lessonData: LessonData[]; personId: number; courseId: number }>,
) {
    try {
        const { lessonData, personId, courseId } = action.payload;
        if (lessonData.length > 0) {
            yield call(http.post, `${Constants.LESSONS_URI}/batch-create`, lessonData);
            yield put(addContentToCourseSucess());
            yield put(getAddedContentListRequest(personId, courseId, true));
            yield put(decreaseTotalSuggested());
        }
    } catch (err) {
        yield put(addContentToCourseFailure(err));
    }
}

export function* getAddedContentList(
    action: PayloadAction<StudentTypes.GET_ADDED_CONTENT_LIST_REQUEST, { personId: number; courseId: number; ignoreLocale: boolean }>,
) {
    try {
        const { personId, courseId, ignoreLocale } = action.payload;

        const path =
            Constants.COURSE_STUDENT_VIEW_URI.replace('%p', personId.toString()).replace('%c', courseId.toString()) + `?ignoreLocale=${ignoreLocale}`;
        const { data } = yield call(http.get, path);
        yield put(getAddedContentListSuccess(data));
    } catch (error) {
        yield put(getAddedContentListFailure(error));
    }
}

export function* deleteContentFromCourseRequest(
    action: PayloadAction<StudentTypes.DELETE_CONTENT_FROM_COURSE_REQUEST, { lessonId: number; personId: number; courseId: number }>,
) {
    try {
        const { lessonId } = action.payload;

        yield call(http.delete, `${Constants.LESSONS_URI}/${lessonId}`);
        yield put(deleteContentFromCourseSuccess(lessonId));
        yield put(increaseTotalSuggested());
    } catch (err) {
        yield put(deleteContentFromCourseFailure(err));
    }
}

export function* reorderContentListRequest(action: PayloadAction<StudentTypes.REORDER_CONTENT_LIST_REQUEST, { lessonId: number; order: number }>) {
    try {
        const { lessonId, order } = action.payload;
        yield call(http.put, `${Constants.LESSONS_URI}/${lessonId}/reorder/${order}`);
        yield put(reorderContentListSuccess(lessonId, order));
    } catch (error) {
        yield put(reorderContentListFailure(error));
    }
}
